import {Component, OnInit} from '@angular/core';
import {AlertService, GroupService, OperatorService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {CountryService} from "../services/country.service";
import {Country} from "../models/country";

@Component({
    templateUrl: './addEditOperator.component.html',
    styleUrls: ['./addEditOperator.component.scss']
})

export class AddEditOperatorComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    countries: any[];

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private operatorService: OperatorService,
        private alertService: AlertService,
        private countryService: CountryService,
    ) {
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            vatId: [''],
            street: [''],
            houseNumber: [''],
            flatNumber: [''],
            city: [''],
            postCode: [''],
            country: ['', Validators.required],
            phone: [''],
            email: [''],
        });

        this.countryService.getAll().subscribe((res: any[]) => {
            this.countries = res;
        }, error => {
            this.alertService.error(error);
        })

        if (!this.isAddMode) {
            this.operatorService.getById(this.id)
                .pipe(first())
                .subscribe(x => {
                    let countryId = null;
                    if (typeof x.country !== 'undefined') {
                        countryId = x.country.id;
                    }
                    this.f.country.setValue(countryId);
                    this.f.name.setValue(x.name);
                    this.f.vatId.setValue(x.vatId);
                    this.f.street.setValue(x.street);
                    this.f.houseNumber.setValue(x.houseNumber);
                    this.f.flatNumber.setValue(x.flatNumber);
                    this.f.city.setValue(x.city);
                    this.f.postCode.setValue(x.postCode);
                    this.f.phone.setValue(x.phone);
                    this.f.email.setValue(x.email);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createOperator();
        } else {
            this.updateOperator();
        }
    }

    private createOperator() {
        this.operatorService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Operator added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateOperator() {
        this.operatorService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
